<template>
  <b-sidebar id="sidebar-cart" title="Carrito" right shadow>
    <template v-slot:title>
      <font-awesome-icon icon="shopping-cart" class="mr-2" />Carrito
    </template>
    <cart ref="cart" viewType="List" @changeTabIndex="tabIndex = $event" />
    <template v-slot:footer>
      <div class="rounded m-2 p-2 d-flex subtotal-line" v-if="tabIndex == 0">
        <div>Subtotal</div>
        <div class="ml-auto">${{ calcSubtotal() }}</div>
      </div>
      <b-button block class="rounded-0" to="/cart"
        >Completar la compra</b-button
      >
    </template>
  </b-sidebar>
</template>
<script>
import { mapState } from "vuex";
import Cart from "@/components/Cart.vue";

export default {
  components: {
    Cart
  },
  data: function() {
    return {
      tabIndex: 0
    };
  },
  computed: {
    ...mapState({
      cartItems: state => state.cart.cartItems
    })
  },
  methods: {
    calcSubtotal: function() {
      let result = 0;
      if(this.$refs.cart){

        this.cartItems.forEach(
          function(element) {
            result += this.$refs.cart.getBookCost(element.id, element.type) * element.quantity;
          }.bind(this)
        );
      
      }

      return result;
    }
  }
};
</script>
